module.exports = "/_next/static/images/phone-graphic-7a629a4f422414272e9e491f2d769dd7.jpg";